<template>
	<sf-data-table
		ref="varTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="variableManagementCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:addRowDatas="addRowDatas"
		:stripe="false"
		selection
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->

			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('MWCC000327') }}
			</sf-button>
			<sf-button color="error" line v-if="isButton_(scrId, 'CD')" icon="trash" :onClick="deleteAction">
				{{ getMessage_('MWCC000328') }}
			</sf-button>
			<!--엑셀업로드 감춤
				
			<sf-button v-if="isButton_(scrId, 'EX')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
			-->
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/Variable/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: []
		};
	},
	/*,
	data() {
		return {
			addRowDatas: [],
			currentTableData: null,
			rowSpanCount: 0
		};
	}
	*/ computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.variableManagements;
		},
		variableManagementCols() {
			//그리드 컬럼
			return [
				{
					label: '* ' + this.getMessage_('QWCC000904'), // 변수ID
					prop: 'varId',
					width: '200px',
					sortable: true,
					align: 'center',
					form: {
						type: 'input',
						isDisabled: this.isDisabled, //추가된행은 편집을 못하게 한다.
						validation: { maxByteSize: 20 }
					}
				},
				{
					label: '* ' + this.getMessage_('QWCC000920'), //시작일자
					prop: 'strtDt',
					width: '180px',
					sortable: true,
					align: 'center',
					form: {
						type: 'date',
						format: 'yyyy-MM-dd',
						valueFormat: 'yyyyMMdd',
						isDisabled: this.isDisabled //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: '* ' + this.getMessage_('QWCC000905'), // 변수값
					prop: 'varVal',
					width: '220px',
					sortable: true,
					align: 'center',
					form: {
						type: 'input',
						validation: { maxByteSize: 60 }
					}
				},
				{
					label: '* ' + this.getMessage_('QWCC000906'), // 비고
					prop: 'rmk',
					width: '800px',
					sortable: true,
					align: 'center',
					form: {
						type: 'input',
						validation: { maxByteSize: 150 }
					}
				},
				{
					label: this.getMessage_('QWCC001163'), // 사용여부
					prop: 'useYn',
					width: '100px',
					sortable: true,
					align: 'center',
					form: {
						type: 'select',
						options: this.gridUseYnList

						// MWCC000355
					}
				},
				{
					label: this.getMessage_('QWCC001814'), // 수정자명
					prop: 'chgrNm',
					width: '90px',
					align: 'center',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001815'), // 수정일
					prop: 'chgrDt',
					align: 'center',
					minWidth: '200px',
					sortable: true
				}
			];
		},
		insVali() {
			return yup.array().of(
				yup.object().shape({
					rmk: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000906')])),
					varVal: yup
						.string()
						.trim()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000905')])),
					strtDt: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000920')])),
					varId: yup
						.string()
						.trim()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000904')])) ///[^A-Z0-9]/g;
						.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC000904')])) //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. 변수ID
				})
			);
		}
	},
	methods: {
		...serviceMethods,
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC000926'), //타이틀바 값 변수관리 엑셀 업로드
				apiGubun: 'variable', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		addAction() {
			//행추가
			this.makeAddDatas();
			this.rows.unshift(...this.addRowDatas);
		} /*,
		changedRow({ rows, changedRow }) {
			//데이터를 뭔가 수정하면 수정 플래그 비트를 넣는다.
			//console.log('[changedRow] rows: ', rows);
			//console.log('[changedRow] changedRow: ', changedRow);

			//console.log('값>>>>>>>>>', changedRow.tableState);

			let tmpStatus = changedRow.tableState;

			if (tmpStatus !== 'I') {
				changedRow.tableState = 'U';
			}
		}*/,
		saveAction() {
			//저장
			const saveListRows = this.$refs.varTable.getSelectedRows();
			//console.log('값은', saveListRows);

			if (saveListRows.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000103'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			try {
				//벨리데이션체크
				this.insVali.validateSync(saveListRows);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(saveListRows) }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		deleteAction() {
			//delete버튼
			//console.log('@@@@ delete action');
			const selected = this.$refs.varTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let delValiGb = false;
			this.$refs.varTable.multipleSelection.forEach(row => {
				if (row.tableState === 'I') {
					delValiGb = true;
				}
			});

			if (delValiGb === true) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000917') });
				return false;
			}

			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.remove(selected) }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
			// console.log('@@@@@@@@@@@@',selected);
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		save(saveRows) {
			// console.log('@@@@ saveRows:', saveRows);

			let sendData = {
				status: 1,
				data: saveRows
			};

			/* 나중에 필요할지 몰라서 주석처리함.
			saveRows.forEach(row => {
				let pushSet = {
					varId: row.varId,
					varValue: row.varValue,
					rmk: row.rmk,
					tableState: row.tableState,
					rgtId: '',
					regDt: '',
					chgId: '',
					chgDt: ''
				};
				sendData.data.push(pushSet);
			});
			*/
			//console.log('@@@@ sendData: ', sendData);
			// return

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setVariableManagement_(sendData)
					.then(value => {
						if (value.message != undefined && value.message != null) {
							this.$sf_toast({
								type: value.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		remove(selected) {
			//console.log('@@@@ delete');
			let sendData = {
				status: 3,
				data: selected
			};

			this.$sf_toggleLoading(true);
			this.setVariableManagement_(sendData)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					// this.$refs.varTable.deleteHandler(false);
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		makeAddDatas() {
			this.addRowDatas = [
				{
					rowType: 'add',
					varId: '',
					strtDt: '',
					varVal: '',
					rmk: '',
					chgrId: '',
					chgrDt: '',
					rgnDt: '',
					rgnId: '',
					tableState: 'I',
					useYn: 'Y'
				}
			];
		}
	}
};
</script>

<style></style>
